export class UpdatePasswordNotesRequest {
    passwordId: number = 0;
    notes: string = "";
}